import angular from 'angular';

angular
  .module('cloudX')
  .controller('AddEmployeeProfileDialogCtrl', [
    '$element',
    '$scope',
    'flySvc',
    'close',
    '$window',
    'resourceFactorySvc',
    addEmployeeProfileDialogCtrl,
  ]);

function addEmployeeProfileDialogCtrl(
  $element,
  $scope,
  flySvc,
  close,
  $window,
  resourceFactorySvc,
) {
  var vm = this;

  var resource = resourceFactorySvc.get('employeeProfile');

  vm.employeeProfile = {
    name: '',
  };

  vm.save = function() {
    if (!vm.employeeProfile.name || vm.saving) return false;
    var model = angular.copy(vm.employeeProfile);
    vm.saving = true;
    resource.post(model).$promise.then(
      function(result) {
        vm.saving = false;
        close(result, 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };

  vm.cancel = function() {
    vm.saving = false;
    close(null, 500);
  };
}
